import {
    FETCH_PENDING_REFERRAL_PAYMENTS_START,
    FETCH_PENDING_REFERRAL_PAYMENTS_SUCCESS,
    FETCH_PENDING_REFERRAL_PAYMENTS_FAILED,
    FETCH_REFERRAL_PAYMENTS_HISTORY_FAILED,
    FETCH_REFERRAL_PAYMENTS_HISTORY_START,
    FETCH_REFERRAL_PAYMENTS_HISTORY_SUCCESS,
    FETCH_REFERRED_USERS_SUCCESS,
    FETCH_REFERRED_USERS_FAILED,
    FETCH_REFERRED_USERS_START,
    REFERRAL_WITHDRAWAL_FAILED,
    REFERRAL_WITHDRAWAL_START,
    REFERRAL_WITHDRAWAL_SUCCESS,
} from "./ActionConstant";

// Referral payments with PENDING status
export function fetchPendingReferralPaymentsStart(data) {
    return {
        type: FETCH_PENDING_REFERRAL_PAYMENTS_START,
        data,
    };
}

export function fetchPendingReferralPaymentsSuccess(data) {
    return {
        type: FETCH_PENDING_REFERRAL_PAYMENTS_SUCCESS,
        data,
    };
}

export function fetchPendingReferralPaymentsFailure(error) {
    return {
        type: FETCH_PENDING_REFERRAL_PAYMENTS_FAILED,
        error,
    };
}

// referral payments history except PENDING status
export function fetchReferralPaymentsHistoryStart(data) {
    return {
        type: FETCH_REFERRAL_PAYMENTS_HISTORY_START,
        data
    }
}

export function fetchReferralPaymentsHistorySuccess(data) {
    return {
        type: FETCH_REFERRAL_PAYMENTS_HISTORY_SUCCESS,
        data
    }
}

export function fetchReferralPaymentsHistoryFailure(data) {
    return {
        type: FETCH_REFERRAL_PAYMENTS_HISTORY_FAILED,
        data
    }
}

// Referred users
export function fetchReferredUsersStart(data) {
    return {
        type: FETCH_REFERRED_USERS_START,
        data
    }
}

export function fetchReferredUsersSuccess(data) {
    return {
        type: FETCH_REFERRED_USERS_SUCCESS,
        data
    }
}

export function fetchReferredUsersFailure(data) {
    return {
        type: FETCH_REFERRED_USERS_FAILED,
        data
    }
}

// Referral withdrawal
export function referralWithdrawalStart(data) {
    return {
        type: REFERRAL_WITHDRAWAL_START,
        data,
    };
}

export function referralWithdrawalSuccess(data) {
    return {
        type: REFERRAL_WITHDRAWAL_SUCCESS,
        data,
    };
}

export function referralWithdrawalFailure(data) {
    return {
        type: REFERRAL_WITHDRAWAL_FAILED,
        data,
    };
}
